var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.profile.turkish)?_c('ElButton',{attrs:{"type":"danger"},on:{"click":_vm.makeTurkish}},[_vm._v(" Flag as Turkish Acc. ")]):_c('ElButton',{attrs:{"type":"danger"},on:{"click":_vm.makeTurkish}},[_vm._v(" Flag as Normal Acc. ")])}
var staticRenderFns = []

export { render, staticRenderFns }